import axios from 'axios';
import { getAuth } from '../providers/AppAuthProvider';
import { Resources } from '../resources/resource';

// const resource = Resources.agentInfo;
import { API_BASE_URL as baseUrl } from 'src/utils/api-url';

export async function inviteCodeConfigUrl(params: any) {
  const url = `${baseUrl}/invite-beta-code-config`;

  const { accessToken } = (await getAuth()) || {};

  const res = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      Accept: 'application/json',
    },
    validateStatus: (s) => s >= 200 && s < 300,
  });

  return res.data?.data ?? res.data;
}
